<template>
    <div id="testPaperList" class="app-inner">
         <div class="public-btn-div flex align-cen" v-if="!topicID && !importName">
            <div class="public-add" @click="addPaper">
            新增试卷
      </div>
         </div>
            <div class="p-tit-c">
        <div class="businessList-filter">
              <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
          <div class="label">试卷名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入试卷名称" v-model="search" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">试卷ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入试卷ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
              </div>
       <div class="businessList-filter-list flex align-cen">
              <div class="fl-le flex align-cen">
          <div class="label">试卷分类：</div>
          <el-cascader
                :options="itemList"
                v-model="value"
                separator="--"
                clearable
                @change="classSelect2"
                change-on-select
                 ref="cascaderRef"
                >
            </el-cascader>
        </div>
      </div>
          <div class="businessList-filter-list flex align-cen" v-if="importName">
              <div class="fl-le flex align-cen">
          <div class="label">练习试卷：</div>
                     <el-select
                        v-model="value2"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in opetion"
                          :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        >
            </el-option>
          </el-select>
        </div>
      </div>
        <div class="businessList-filter-list flex align-cen" v-if="!importName">
        <div class="label">考试时间：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(0)"
        >
          不限
        </div>
        <el-radio v-model="radio" label="1" @change="classSelect" >有时间限制</el-radio>
        <el-radio v-model="radio" label="2" @change="classSelect">无时间限制</el-radio>
      </div>
         <div class="businessList-filter-list flex align-cen">
        <div class="label">考试状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio(1)"
        >
          不限
        </div>
        <el-radio v-model="radio1" label="0" @change="classSelect" >未开始</el-radio>
        <el-radio v-model="radio1" label="1" @change="classSelect">考试中</el-radio>
         <el-radio v-model="radio1" label="2" @change="classSelect">已考完</el-radio>
      </div>
       <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件
        </div>
      </div>
        </div>
            </div>
              <div class="businessList-container">
        <div class="businessList-container-table">
                  <el-table
                  ref="multipleTable"
            :data="list"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
          :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          @select='onTableSelect'
            >
            <el-table-column type="selection" width="55" reserve-selection v-if="importName"> 
            </el-table-column>
            <el-table-column label="试卷封面" align="center" prop="pic">
            <template slot-scope="scope" >
                <img :src="scope.row.logo ? scope.row.logo : require('../../assets/images/nullimg.png')" alt="" style="display: block;width:50%;margin:0 auto" v-if="scope.row.id !=0"> 
            </template>
         </el-table-column>
            <el-table-column prop="id" label="试卷ID" align="center" width="200">
          </el-table-column>
           <el-table-column prop="paperName" label="试卷名称" align="center" width="300">
          </el-table-column>
          <el-table-column prop="classifyName" label="试卷分类" align="center" >
          </el-table-column>
          <el-table-column prop="examNum" label="考试人次" align="center" >
          </el-table-column>
           <el-table-column prop="" label="考试时间" align="center" >
             <template slot-scope="scope">
              <div>
                {{scope.row.answerTimeLimit ? `${scope.row.answerTimeLimit}分钟` : '-'}}
              </div>
             </template>
          </el-table-column>
           <el-table-column prop="questionNum" label="题目数" align="center" >
          </el-table-column>
          <el-table-column prop="" label="练习试卷" align="center" v-if="importName">
             <template slot-scope="scope">
              <div>
                {{scope.row.practiceMode == 1 || scope.row.practiceMode == 2 ? '是' : '否'}} 
              </div>
             </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="200" > 
            <template slot-scope="scope">
            <el-button type="warning" plain v-if="scope.row.state == '0'">未开始</el-button>
            <el-button type="danger" plain v-if="scope.row.state == '1'">考试中</el-button>
              <el-button type="info" plain v-if="scope.row.state == '2'">已考完</el-button>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="400"
           v-if="!topicID && !importName"
            >
             <template slot-scope="scope">
                 <el-button type="text" size="small"  slot="reference" style="color:red" @click="openExamPreview(scope.row)">预览考试</el-button>
                  <el-button type="text" size="small"  slot="reference" style="color:red" v-if="scope.row.state == '1'" @click="changeStatus(scope)">停止考试</el-button>
                   <el-button type="text" size="small"  slot="reference" style="color:red" v-if="scope.row.state == '2'" @click="changeStatus(scope)">重新开考</el-button>
                  <el-button type="text" size="small"  slot="reference" style="color:red" @click="openscoreAnalysis(scope.row)">统计分析</el-button>
                   <el-button type="text" size="small"  slot="reference" style="color:red" @click="openPaper(scope.row)">编辑试卷</el-button>
                    <el-button type="text" size="small"  slot="reference" style="color:red" @click="openmoniToring(scope.row)">考试监控</el-button>
                    <el-dropdown>
                        <span class="el-dropdown-link" style="color:red;font-size:12px;margin-left: 10px;cursor: pointer;font-weight: bold;">
                          更多<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                           <el-dropdown-item @click.native="sharePaper(scope.row)" v-if="scope.row.state == '1'">分享试卷</el-dropdown-item>
                          <el-dropdown-item @click.native="copyPaper(scope.row)">复制试卷</el-dropdown-item>
                          <el-dropdown-item @click.native="PrintingPaper(scope.row)">打印试卷</el-dropdown-item>
                          <el-dropdown-item @click.native="exportPaper(scope.row)"> 导出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
             </template>
          </el-table-column>
            </el-table>
             <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
              </div>
              <!-- 重新开考 -->
                   <el-dialog
                title="重新开考"
                :visible.sync="centerDialogVisible"
                width="30%"
                :append-to-body="true"
                center
                >
                    <div class="forminfo">
                        <div class="setdia-check">
                               <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">有效期限</p>
                        </div>
                          <div class="settings-box-radio flex align-cen" style="padding-bottom:20px">
                             <el-radio v-model="validPeriod" label="1">试卷开放时间</el-radio>
                              <el-date-picker
                                v-model="value1"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions2"
                                @change="classSelect1"
                                >
                                </el-date-picker>
                        </div>
                        <div class="settings-box-radio flex align-cen">
                             <el-radio v-model="validPeriod" label="2">永久有效</el-radio>
                        </div>
                    </div>
                        </div>
                 <div class="businessList-filter-list flex align-cen public-btn-small" style="justify-content:center;padding-left:0px">
                         <div class="public-btn-small-plan" style="margin-right:30px" @click="centerDialogVisible = false">
                        取消
                        </div>
                          <el-button type="primary" class="public-btn-small-primary public-btn-small-load"
                            @click.stop="submit"
                            >
                              确定
                            </el-button>
                    </div>
                    </div>
                   </el-dialog>
        <el-dialog
  title="分享试卷"
  :visible.sync="centerDialogVisible1"
  width="440px"
  :append-to-body="true"
  center>
     <div class="dia-can">
      <div class="section-title" style="padding-bottom:10px;font-weight:500">方式一：二维码分享</div>
                 <vue-canvas-poster :widthPixels="370" :painting="painting" @success="shanrSuccess" @fail="fail"></vue-canvas-poster>
            </div>
            <div class="dia-btn" @click="$util.downloadFile(dowloadImgName,posterImg)">下载二维码</div>
  <div class="linkdiv">
      <div class="section-title"  style="padding-top:30px;font-weight:500">方式二：复制链接考试</div>
     {{link}}
    <div class="linkdiv-btn flex align-cen">
       <div @click.stop="copy(link,1)"  class="btn-set exportExamSa">复制链接</div>
       <div @click.stop="copy(link,2)" class="btn-set ">直接打开</div>
    </div>
  </div>
</el-dialog>
    </div>
</template>
<script>
import {getPaperList,listTree,editPapeItem,copyPa} from "@/api/enterprise/index"  //试卷列表、试卷分类、修改试卷、复制试卷
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'testPaperList',
    components:{
      paginaTion
    },
          props: {
    topicID: [String, Number],
        importName: [String, Number],
    isAppId:[Boolean]
  },
    data() {
        return {
           opetion:[
            {
              id:1,
              name:'是'
            },
            {
               id:0,
              name:'否'
            }
          ],
          value2:'',
           selsctarr:[],
           multipleSelection:[],
            catchStatus:false,
                sharedata:{},
               painting: {
                    width: '371px',
                    height: '420px',
                    background: '#f4f5f7',
                    borderRadius:'20px',
                    views: [
                        {
                            type: 'image',
                            url: '',
                            css: {
                                top: '0px',
                                left: '0px',
                                borderRadius:'20px 20px 0 0',
                                width: '371px',
                                height: '130px'
                            },
                        },
                        {
                            type:'text',
                            text: '',
                            css: {
                                top:'140px',
                                 width: "100%",
                            textAlign: "center",
                            fontSize: "14px",
                            maxLines: "2",
                            lineHeight: "20px"
                            }
                        },
                         {
                        type: 'qrcode',
                        content: '',
                        css: {
                            top: '200px',
                            left: '110px',
                            color: '#000',
                            width: '150px',
                            height: '150px'
                        }
                        },
                          {
                            type:'text',
                            text: '技术支持：南京睿首智能技术研究院',
                            css: {
                                bottom:'20px',
                                left:'0px',
                                 width: "100%",
                                textAlign: "center",
                                fontSize: "12px",
                                maxLines: "1",
                                color: '#333',
                            }
                        }
                        // ....
                    ],
                }, 
                link:'',
           dowloadImgName:'分享试卷',
          posterImg:'',
          centerDialogVisible1:false,
            value1:[],
            validPeriod:'1',
            showFromTime:'',
            showUntilTime:'',
            centerDialogVisible:false,
            dataProp:{},
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            list:[],
            value:[],
            itemList:[],
            search:'',
            search1:'',
            radio:'',
            radio1:'',
            questionId:'',
                     pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
    activated(){
        this.gethisInfo()
        this.getthisClass()
    },
    created () {
        this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
        this.questionId = this.topicID || ''
        this.gethisInfo()
       if(this.importName) this.getthisClass()
    },
    methods: {
       // 表格选择
         handleSelectionChange(val) {
           this.multipleSelection = val;
           this.$emit('sendStatus', this.multipleSelection,false)
         },
                // 手动选择
    onTableSelect(rows, row){
         this.catchStatus = rows.length && rows.indexOf(row) !== -1
    },
         getRowKeyOfTarget(row) {
            return row.id
            },
                // 新增修改调用方法
        editfun(val){
            this.selsctarr = val        
        },
         // 新增修改调用清空方法
        remove(){
           this.multipleSelection = []
        },
       shanrSuccess(src) {
             this.posterImg = src;
            },
            fail(err) {
                console.log('fail', err)
            },
          // 打开导出word页面
      exportPaper(data){
        this.$router.push({
            name: "enExportWord",
            query:{
                id:data.id,
            }
           })
      },
         // 打开打印试卷
      PrintingPaper(data){
        this.$router.push({
            name: "enPrintingPaper",
            query:{
                id:data.id,
            }
           })
      },
       // 手动修改views
        handleChangeImg(data){
            this.painting.views[0].url = data.logo ? data.logo : require('../../assets/images/banner1.jpg')
            //  this.painting.views[0].url = require('../../assets/images/banner1.jpg')
             this.painting.views[1].text = data.paperName
             this.painting.views[2].content = this.$config.prUrl + '#/myExam/examLogin?id=' + data.id + '&businessId' + this.businessInfo.id
        },
      // 分享试卷
      sharePaper(data){
        this.centerDialogVisible1 = true
        this.sharedata = data
      this.handleChangeImg(data)
      this.dowloadImgName = data.paperName
      this.link = this.$config.prUrl + '#/myExam/examLogin?id=' + data.id + '&businessId' + this.businessInfo.id
      },
         copy(link,type){
             let _self = this
           if(type == 1){
              this.$copyText(link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
           }else{
                 const newurl = this.$router.resolve({name: 'examLogin', query: {id: this.sharedata.id,businessId:this.businessInfo.id}})
                 window.open(newurl.href,'_blank')
           }
    },
          // 复制试卷
    copyPaper(data){
 this.$prompt('请输入试卷名称', '复制试卷', {
          confirmButtonText: '复制',
          cancelButtonText: '取消',
          inputPattern:  /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/,
          inputErrorMessage: '请正确输入试卷名称'
        }).then(({ value }) => {
         let params = {
          id:data.id,
          paperName:value,
          businessId:this.businessInfo.id
         }
         copyPa(params)
         .then(res =>{
          if(res.code == 0){
            this.$util.Notifi('复制成功','success','fa-check')
            this.currentPage = 1
            this.gethisInfo()
          }else{
            this.$util.Notifi(res.msg,'error','fa-exclamation-circle')
          }
         })
        }).catch(() => {
          
        });
    },
      // 打开统计分析
      openscoreAnalysis(data){
        this.$router.push({
            name: "enScoreAnalysis",
            query:{
                id:data.id,
            }
           })
      },
      // 打开考试监控
      openmoniToring(data){
        this.$router.push({
            name: "enMoniToring",
            query:{
                id:data.id,
            }
           })
      },
      // 打开预览考试
      openExamPreview(data){
        this.$router.push({
            name: "previewExam",
            query:{
                id:data.id,
            }
           })
      },
      //打开新增试卷
      openPaper(data){
        if(data.classifyId == 2){
             return this.$util.Notifi('平台端题目不允许修改','error','fa-exclamation-circle')
          }
         this.$router.push({
            name: "addEnTestPaper",
            query:{
                id:data.id,
            }
           })
      },
          // 应用状态改变
    changeStatus(e){
      if(e.row.classifyId == 2){
             return this.$util.Notifi('平台端试卷不允许修改','error','fa-exclamation-circle')
          }
     if(e.row.state == 1){
           this.$confirm('确定停止考试吗？', '停止考试', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editPaper(e)
                        }).catch(() => {          
                        });
        }else{
            this.dataProp = e
            this.centerDialogVisible = true
        }
      },
      submit(){
        if(this.validPeriod == '1' && !this.showFromTime) return  this.$util.Notifi('请选择试卷开放开始时间','error','fa-exclamation-circle')
        if(this.validPeriod == '1' && !this.showUntilTime) return  this.$util.Notifi('请选择试卷开放结束时间','error','fa-exclamation-circle')
        this.editPaper(this.dataProp)
      },
       editPaper(e){
             let params = {}
             if(e.row.state == 1 ){
                params = {
                id:e.row.id,
                state:'2'
                }
             }else{
                params = {
                id:e.row.id,
                validPeriod:this.validPeriod,
                showFromTime:this.showFromTime,
                showUntilTime:this.showUntilTime
                }
             }
             editPapeItem({
                ...params,
                businessId:this.businessInfo.id
                    },'put','enterprise')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('状态修改成功'); 
                       this.centerDialogVisible = false
                    this.gethisInfo()
                  }
                })
                .catch(err => {
                })
        },
        // 新增试卷
        addPaper(data){
            data.id ? this.$router.push({name:'addEnTestPaper',query:{id:data.id}}) : this.$router.push({name:'addEnTestPaper',query:{}})
        },
        // 重置
        reset(){
          this.search=""
          this.search1=""
          this.value=""
           this.value2=""
          this.radio1=""
          this.radio=""
          this.questionId = this.topicID || ''
          this.currentPage=1
          this.gethisInfo()
        },
        allradio(type){
              type == 0 ? this.radio = '' : this.radio1 = ''
            this.currentPage = 1
            this.gethisInfo()
        },
        // 筛选
        classSelect(){
            this.currentPage = 1
            this.gethisInfo()
        },
        classSelect1(){
             this.showFromTime = this.value1[0]
            this.showUntilTime = this.value1[1]
        },
        // 筛选
        classSelect2(value){
            this.currentPage = 1
            if(value){
                let index = value.length-1
                this.value = value[index]
            }else{
              this.value = ""
            }
            this.gethisInfo()
        },
            emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisInfo()
      },
        // 获取试卷列表
        gethisInfo(){
            if(typeof(this.value) == "undefined") this.value = ""
             let params = {
                paperName:this.search ,
                id:this.search1,
                classifyId:this.value,
                state:this.radio1,
                validPeriod:this.radio,
                questionId:this.questionId,
                practiceMode:this.value2,
                current: this.currentPage,
                size:this.PageSize,
                businessId:this.businessInfo.id
            }
            getPaperList(params,'enterprise')
            .then(res =>{
                this.list = res.data.records
             this.totalCount = res.data.total;
               if(this.importName){
              let rows = []
                         for (let m = 0; m < this.selsctarr.length; m++) {
                        for (let n = 0; n < this.list.length; n++) {
                        if (this.selsctarr[m].id === this.list[n].id || this.selsctarr[m].paperId === this.list[n].id) {
                            
                            rows.push(this.list[n])
                        }
                        }
                    }
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row,true)
                    })
             }
            })
            .catch(err =>{})
        },
             // 获取=试卷分类
        getthisClass(){
            this.itemList = []
             listTree({
                name:'',
                businessId:this.businessInfo.id
             },'enterprise')
            .then(res => {
              if(res.data !==null){
                for (const key in res.data) {
                  this.itemList.push({
                    value:res.data[key].id,
                    label:res.data[key].name,
                    children:res.data[key].children ? [] : ''
                  }) 
                  if(res.data[key].children){
                    for (const i in res.data[key].children) {
                        this.itemList[key].children.push({
                            value:res.data[key].children[i].id,
                            label:res.data[key].children[i].name
                        })
                    }
                  } 
                }
              }else{
                    this.itemList = []
             }

            })
            .catch(err => {
            })
        },
    },

}
</script>
<style lang="scss" scoped>
    .forminfo{
        .setdia-check{
            padding: 0 10px;
                    .settings-box{
            margin-bottom: 48px;
            .settings-box-tips{
                margin-bottom: 20px;
                .red-div{
                    width: 4px;
                    height: 15px;
                    background-color: #409eff;
                    margin-right: 5px;
                }
                .red-div-p{
                 font-size: 16px;
                letter-spacing: 0px;
                color: #333333!important;
                height: unset;
                font-weight: 700;
                }
            }
        }
        }
   
    }
    ::v-deep{
        .el-button--warning.is-plain:hover, .el-button--warning.is-plain:focus{
           background: #fdfaf1 !important;
      border-color: #f7ebc9 !important;
      color: #ebce77 !important;
        }
    .el-button--danger.is-plain:hover, .el-button--danger.is-plain:focus{
         background: #fef0f0 !important;
      border-color: #fbc4c4 !important;
      color: #f56c6c !important;
    }
    .el-button--info.is-plain:hover, .el-button--info.is-plain:focus{
      background: #f4f4f5 !important;
      border-color: #d3d4d6 !important;
      color: #909399 !important;
    }
    }
    ::v-deep {
       .el-dialog{
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
        }
                .dia-can{
        .canvas{
            position:relative !important;
            top: 0 !important;
            display: block;
            margin: 0 auto;
        }
    }
    .linkdiv-btn{
      justify-content: center;
      margin-top: 10px;
      .btn-set{
     min-width: 120px;
    margin-right: 16px;
    cursor: pointer;
    color: #409eff;
    border: 1px solid #409eff;
    padding: 7px 10px;
    border-radius: 4px !important;
    text-align: center;
      }
      .exportExamSa{
            border: none;
    background: #409eff;
    color: #fff;
      }
    }
           .dia-btn{
            width: 120px;
        	height: 32px;
				line-height: 30px;
				font-size: 14px;
				padding: 0 16px;
				border-radius: 2px;
				font-family: inherit;
				border-width: 1px;
				border-style: solid;
				text-align: center;
				vertical-align: middle;
				box-sizing: border-box;
				cursor: pointer;
				transition: all .3s;
				background: $base-color-btn;
				color: #fff;
                margin: 20px auto;
                margin-bottom: 0;
    }
}
</style>